type UpdateRegistration = Pick<ServiceWorkerRegistration, 'active' | 'installing' | 'update'>

export function startServiceWorkerUpdates(
  url: string,
  registration: UpdateRegistration,
  reportUnexpectedError: (error: unknown) => void,
  interval = 3600_000,
) {
  let checking = false
  let stopped = false
  let timer: ReturnType<typeof setInterval>
  const stop = () => {
    stopped = true
    clearInterval(timer)
  }

  async function check() {
    if (stopped || checking || !navigator.onLine || registration.installing
      || registration.active?.state !== 'activated') {
      return
    }
    checking = true
    try {
      let response: Response
      try {
        response = await fetch(url, {
          cache: 'no-store',
          headers: { 'cache': 'no-store', 'cache-control': 'no-cache' },
        })
      }
      catch (error) {
        // Browsers reject fetch with TypeError/NetworkError when no response arrives.
        if (error instanceof TypeError || (error instanceof DOMException && error.name === 'NetworkError')) {
          return
        }
        throw error
      }
      if (response.status !== 200 || stopped || !navigator.onLine
        || registration.installing || registration.active?.state !== 'activated') {
        return
      }
      try {
        await registration.update()
      }
      catch (error) {
        if (error instanceof DOMException && error.name === 'InvalidStateError') {
          // This registration is no longer usable. A new activation starts a new poll.
          stop()
          return
        }
        throw error
      }
    }
    catch (error) {
      reportUnexpectedError(error)
    }
    finally {
      checking = false
    }
  }

  timer = setInterval(() => {
    void check()
  }, interval)
  return stop
}
